import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConsumerPortalAdminConfig } from '../../../../models/consumer-portal-admin-config';
import { AppMediatorService } from '../../../../services/app-mediator.service';

@Component({
    standalone: false,
    selector: 'por-admin-overview',
    templateUrl: './admin-overview.component.html',
    styleUrls: ['./admin-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminOverviewComponent implements OnInit {
    private readonly translateService = inject(TranslateService);
    private readonly appMediatorService = inject(AppMediatorService);

    @Input() adminConfig!: ConsumerPortalAdminConfig;

    ngOnInit(): void {
        const lang = this.appMediatorService.localStorageService.selectedContentLanguage;
        if (lang && lang !== this.translateService.getCurrentLang()) {
            this.translateService.use(lang);
        }
    }
}
